import React from "react";
import ErrorMessage from "../ErrorMessage";
import "./textarea.scss";

const TextArea = ({
  placeholder = "Enter here",
  value = "",
  error,
  messages,
  rows,
  cols,
  name = "",
  label = "",
  register,
  required = false,
}) => {
  return (
    <div>
      <label className="inputLabel">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <textarea
        className="normaltextarea"
        name={name}
        defaultValue={value}
        ref={register}
        rows={rows}
        cols={cols}
        placeholder={placeholder}
      />
      <ErrorMessage error={error} messages={messages} />
    </div>
  );
};

export default TextArea;
